export function toDate(value?: string | Date): Date | null {
    if (!value) return null;
    return new Date(value);
}
